<div class="wrapper-confetti" :class="rainConfetti ? '' : 'hidden'"><div v-for="i in amount" :class="confettiClass(i)" :style="confettiStyle()"></div></div>